import React from 'react';
import { IconButton, makeStyles, Typography } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    marginRight: 8
  },
  icon: {
    width: 24,
    height: 24,
    borderRadius: 12,
    border: '1px solid rgba(0,0,0,0)'
  },
  text: {
    padding: 0,
    margin: 0,
    height: '100%',
    lineHeight: 1.7
  },
  iconSelected: {
    width: 24,
    height: 24,
    borderRadius: 12,
    border: '1px solid grey'
  }
}));


/**
 * Day Icon.
 * @param {day, selected, toggle} props Day of week (0,1,2,...). Toggle selection.
 */
function DayIcon(props) {
  const { day, selected, toggle } = props;
  const classes = useStyles();

  return (
    <IconButton
      size='small'
      className={classes.root}
      onClick={toggle}
    >
      <div className={selected ? classes.iconSelected : classes.icon}>
        <Typography variant='body2' className={classes.text}>
          {day}
        </Typography>
      </div>
    </IconButton>
  );
}

export default DayIcon;
